import React, { ReactNode } from 'react'

interface AnnouncementBannerProps {
    children: ReactNode
    className?: string
    bgColor?: string
    textColor?: string
}

const AnnouncementBanner: React.FC<AnnouncementBannerProps> = ({
    children,
    className = '',
    bgColor = 'bg-blue-900',
    textColor = 'text-white',
}) => {
    return <div className={`w-full ${bgColor} px-4 py-2 text-center md:px-6 ${textColor} ${className}`}>{children}</div>
}

export default AnnouncementBanner
